import urlPrefix from "./apiPrefix";

export const putCalcItemAttributeUpdate = () => `${urlPrefix.value}/tax-web-control/api/calc-item-attribute/update`;
export const postCalcItemAttributeCreate = () => `${urlPrefix.value}/tax-web-control/api/calc-item-attribute/create`;
export const getCalcItemAttribute = (id: number) => `${urlPrefix.value}/tax-web-control/api/calc-item-attribute/${id}`;
export const getCalcItemAttributeList = () => `${urlPrefix.value}/tax-web-control/api/calc-item-attribute/list`;
export const getCalcItemAttributeListActive = () => `${urlPrefix.value}/tax-web-control/api/calc-item-attribute/listActive`;
export const deleteCalcItemAttribute = (id: number) => `${urlPrefix.value}/tax-web-control/api/calc-item-attribute/delete/${id}`;
